import { Reveal } from "@/components/yanre/Reveal";
import { useLocale } from "@/i18n/LocaleContext";

// SECTION — Made for Real Training. Final approved PT Studio category images
// (user-supplied masters in /media, web-optimized webp derivatives).
const CATEGORIES = [
  { key: "strength", img: "/media/yanre-personal-studio-strength-900.webp", labelKey: "pts.eq.strength", labelDefault: "Strength", altKey: "pts.eq.alt.strength", alt: "YANRE professional strength equipment for personal training studios" },
  { key: "functional", img: "/media/yanre-personal-studio-functional-training-900.webp", labelKey: "pts.eq.functional", labelDefault: "Functional Training", altKey: "pts.eq.alt.functional", alt: "YANRE functional training equipment for professional fitness studios" },
  { key: "free-weights", img: "/media/yanre-personal-studio-free-weights-900.webp", labelKey: "pts.eq.freeweights", labelDefault: "Free Weights", altKey: "pts.eq.alt.freeweights", alt: "YANRE professional free weight equipment for personal training studios" },
  { key: "benches-racks", img: "/media/yanre-personal-studio-benches-racks-900.webp", labelKey: "pts.eq.benches", labelDefault: "Benches & Racks", altKey: "pts.eq.alt.benches", alt: "YANRE professional benches and racks for personal training studios" },
  { key: "cable-stations", img: "/media/yanre-personal-studio-cable-stations-900.webp", labelKey: "pts.eq.cable", labelDefault: "Cable Stations", altKey: "pts.eq.alt.cable", alt: "YANRE professional cable stations for personal training studios" },
  { key: "cardio", img: "/media/yanre-personal-studio-cardio-900.webp", labelKey: "pts.eq.cardio", labelDefault: "Cardio", altKey: "pts.eq.alt.cardio", alt: "YANRE professional cardio equipment for personal training studios", fit: "contain" },
];

export const PTEquipment = () => {
  const { t } = useLocale();
  return (
    <section className="section-darker py-24 lg:py-32" data-testid="pt-equipment-section">
      <div className="container-edge">
        <Reveal>
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-10 bg-signal" />
            <span className="overline">{t("pts.eq.label", "Made for Real Training")}</span>
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="max-w-4xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
            {t("pts.eq.h2a", "Commercial-grade.")}{" "}
            <span className="text-signal">{t("pts.eq.h2b", "Built for daily professional use.")}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-titanium/75 sm:text-lg">
            {t(
              "pts.eq.copy",
              "The same equipment lines that serve commercial gyms — engineered frames, patented movement and factory-tested durability — scaled intelligently for a private training studio."
            )}
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="pt-equipment-grid">
          {CATEGORIES.map((cat, i) => (
            <Reveal key={cat.key} delay={0.06 * i}>
              <figure className="group relative overflow-hidden border border-carbon-700 bg-carbon-900" data-testid={`pt-equipment-${cat.key}`}>
                <img
                  src={cat.img}
                  alt={t(cat.altKey, cat.alt)}
                  loading="lazy"
                  decoding="async"
                  className={`aspect-[4/3] w-full ${cat.fit === "contain" ? "object-contain" : "object-cover"} opacity-80 transition-all duration-500 group-hover:scale-[1.03] group-hover:opacity-100`}
                />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-carbon-950/95 to-transparent px-5 pb-4 pt-12">
                  <span className="font-display text-lg font-bold uppercase tracking-wide text-white">{t(cat.labelKey, cat.labelDefault)}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
